import { AnalyticsClient } from './AnalyticsClient';
import { AnalyticsEvent } from './analyticsEvents';

export class AnalyticsService {
  private hasInitialised = false;

  constructor(
    private readonly client: AnalyticsClient,
    private readonly isEnabled: () => boolean
  ) {}

  initialise(): void {
    if (!this.isEnabled()) {
      return;
    }

    if (this.hasInitialised) {
      return;
    }

    this.client.initialise();
    this.hasInitialised = true;
  }

  trackEvent(event: AnalyticsEvent): void {
    if (!this.isEnabled()) {
      return;
    }

    this.client.trackEvent(event.name, event.params);
  }
}
